"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getElementHeight = getElementHeight;
exports.getElementWidth = getElementWidth;
function getElementWidth(selector) {
  var _element$clientWidth;
  if (!selector) return 0;
  var element = document.querySelector(selector);
  return (_element$clientWidth = element === null || element === void 0 ? void 0 : element.clientWidth) !== null && _element$clientWidth !== void 0 ? _element$clientWidth : 0;
}
function getElementHeight(selector) {
  var _element$clientHeight;
  if (!selector) return 0;
  var element = document.querySelector(selector);
  return (_element$clientHeight = element === null || element === void 0 ? void 0 : element.clientHeight) !== null && _element$clientHeight !== void 0 ? _element$clientHeight : 0;
}